import React from 'react';
import UploadManager from './UploadManager';
const meta = {
    title: 'Features/CustomerFileDrop/UploadManager',
    component: UploadManager,
    tags: ['autodocs'],
    parameters: { layout: 'padded' },
    args: {
        folderId: 1
    }
};
export default meta;
/**
 * FileHandler dropzone + staged queue. Live PUT requires app APIs;
 * Storybook shows empty staging UI (presign is not mocked here).
 */
export const EmptyDropZone = {
    render: (args) => (React.createElement(UploadManager, { folderId: args.folderId, onUploadsComplete: () => undefined }))
};
